module.exports = __webpack_public_path__ + "img/15.full.03433d39.webp";